import { isValidElement, ReactNode } from 'react';
import { QueryCache } from '@tanstack/react-query';

import { addErrorToast } from '@/shared/components/Toasts';

const isReactNode = (value: unknown): value is ReactNode => {
  if (
    value === null ||
    value === undefined ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.every(isReactNode);
  }

  return isValidElement(value);
};

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const isValidError = (
  error: unknown
): error is { title: ReactNode; text: ReactNode } => {
  if (!isObject(error)) return false;

  return isReactNode(error.title) && isReactNode(error.text);
};

export const queryCache = new QueryCache({
  onError: (_, query) => {
    const { meta } = query;
    const { error } = meta ?? {};

    if (isValidError(error)) {
      addErrorToast({ title: error.title, text: error.text });
    }
  },
});
